export interface PricingFeature {
  key: string
  label: string
  included: boolean
}

export interface PricingTier {
  key: string
  name: string
  price: string
  priceNote: string
  highlighted: boolean
  features: PricingFeature[]
}

export const pricingFeatures: PricingFeature[] = [
  { key: 'all-integrations', label: 'pricing.features.allIntegrations', included: true },
  { key: 'sales-forecasting', label: 'pricing.features.salesForecasting', included: true },
  { key: 'unlimited-users', label: 'pricing.features.unlimitedUsers', included: true },
  { key: 'inventory-management', label: 'pricing.features.inventoryManagement', included: true },
  { key: 'warehouse-management', label: 'pricing.features.warehouseManagement', included: true },
  { key: 'product-management', label: 'pricing.features.productManagement', included: true },
  { key: 'order-management', label: 'pricing.features.orderManagement', included: true },
  { key: 'listing-management', label: 'pricing.features.listingManagement', included: true },
  { key: 'dedicated-support', label: 'pricing.features.dedicatedSupport', included: true },
  { key: 'ai-image-generation', label: 'pricing.features.aiImageGeneration', included: true },
  { key: 'performance-analytics', label: 'pricing.features.performanceAnalytics', included: true },
  { key: 'ad-monitoring', label: 'pricing.features.adMonitoring', included: true },
  { key: 'task-workflows', label: 'pricing.features.taskWorkflows', included: true },
  { key: 'bulk-updates', label: 'pricing.features.bulkUpdates', included: true },
  { key: 'synced-listings', label: 'pricing.features.syncedListings', included: true },
  { key: 'custom-reports', label: 'pricing.features.customReports', included: true }
]

export const pricingTier: PricingTier = {
  key: 'professional',
  name: 'pricing.tier.name',
  price: '$999',
  priceNote: 'pricing.tier.priceNote',
  highlighted: true,
  features: pricingFeatures
}
